// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBbUUjgMc--7Tdr12k6eexTx2kfhyGsu_Q',
    authDomain: 'kutyavalegymosolyert-admin.firebaseapp.com',
    databaseURL: 'https://kutyavalegymosolyert-admin.firebaseio.com',
    projectId: 'kutyavalegymosolyert-admin',
    storageBucket: 'kutyavalegymosolyert-admin.appspot.com',
    messagingSenderId: '823532617441',
    appId: '1:823532617441:web:7180db55165dc0823b81a0',
    measurementId: 'G-XRNFXCG6MF'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
